import React from 'react'
import {
  pluralizeRu,
} from './departmentDetailUtils'

function DepartmentTeamTabs ({
  teams,
  activeKey,
  onChange,
  loading,
}) {
  if (loading) {
    return <p className="info-note">Загрузка команд…</p>
  }

  if (!teams?.length) {
    return <p className="info-note">Команды не созданы</p>
  }

  return (
    <div className="department-team-tabs" role="tablist" aria-label="Команды">
      {teams.map((team) => {
        const active = team.key === activeKey
        return (
          <button
            key={team.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`department-team-tab${active ? ' department-team-tab-active' : ''}`}
            onClick={() => onChange(team.key)}
          >
            <span className="department-team-tab-code">{team.name}</span>
            <span className="department-team-tab-meta">
              {team.membersCount} {pluralizeRu(team.membersCount, 'чел.', 'чел.', 'чел.')} · {team.leadName}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default DepartmentTeamTabs
